/**
 * Placeholder pages for routes not yet implemented.
 * Each will be replaced week by week.
 */

function PlaceholderPage({ title, description }) {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
      </div>
      <div className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center">
        <p className="text-slate-400 text-sm">Coming soon — check the sprint plan for the target week.</p>
      </div>
    </div>
  );
}

export function AssetsPage() {
  return <PlaceholderPage title="Assets" description="Full asset list coming in Week 2." />;
}

export function MyAssetsPage() {
  return <PlaceholderPage title="My Assets" description="Assets assigned to you." />;
}

export function LabelsPage() {
  return <PlaceholderPage title="Print Labels" description="QR label printing coming in Week 3." />;
}

export function StoragePage() {
  return <PlaceholderPage title="Storage Units" description="Storage unit management coming in Week 3." />;
}

export function EmployeesPage() {
  return <PlaceholderPage title="Employees" description="HR-synced employee list coming in Week 4." />;
}

export function AdminPage() {
  return <PlaceholderPage title="Admin Settings" description="System settings, HR sync, and user management." />;
}

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <p className="text-6xl font-bold text-slate-200">404</p>
        <p className="text-slate-600 mt-4">Page not found.</p>
        <a href="/" className="mt-4 inline-block text-primary-600 hover:underline text-sm">
          Go home
        </a>
      </div>
    </div>
  );
}
